<template>
  <div class="container">
    <div class="card shadow-sm border-0 mt-5 mb-3">
      <div class="card-header bg-white">
        <div class="d-flex justify-content-between">
          <h5>{{ course.title }}</h5>
        </div>
      </div>
      <div class="card-body">
        <div v-if="!course.isOnline" class="row" style="margin-top: 45px">
          <div class="col-md-4 d-flex flex-column align-items-center">
            <i class="course-icon fa fa-calendar"></i>
            <p class="course-data text-center">
              <small>{{ course.date }}</small>
            </p>
          </div>
          <div class="col-md-4 d-flex flex-column align-items-center">
            <i class="course-icon fa fa-clock"></i>
            <p class="course-data text-center">
              <small>{{ course.schedule }}</small>
            </p>
          </div>
          <div class="col-md-4 d-flex flex-column align-items-center">
            <i class="fa course-icon fa-map-pin"></i>
            <p class="course-data text-center">
              <small>{{ course.location }}</small>
            </p>
          </div>
        </div>
        <form @submit="update">
          <div class="">
            <div class="form-group mb-3">
              <label class="form-label">Título</label>
              <input
                type="text"
                class="form-control"
                v-model="updateCourse.title"
              />
            </div>
            <div class="form-group mb-3">
              <label class="form-label">Subtítulo</label>
              <input
                type="text"
                class="form-control"
                v-model="updateCourse.subtitle"
              />
            </div>
            <div class="form-group mb-3">
              <label class="form-label">Sumario</label>
              <QuillEditor
                ref="quillEditor"
                theme="snow"
                v-model:content="updateCourse.summary"
                contentType="html"
              />
            </div>
            <div class="form-group mb-3">
              <label class="form-label">Imagen de portada</label>
              <input
                type="file"
                class="form-control"
                @change="uploadCoverImage"
                accept="image/*"
              />
            </div>
            <div class="form-group mb-3">
              <label class="form-label">Fecha de lanzamiento</label>
              <input
                type="date"
                class="form-control"
                v-model="updateCourse.releaseDate"
              />
            </div>
            <div class="row">
              <div class="col-md-4 form-group mb-3">
                <label class="form-label">Horas totales</label>
                <input
                  type="number"
                  class="form-control"
                  v-model="updateCourse.totalHours"
                />
              </div>
              <div class="col-md-4 form-group mb-3">
                <label class="form-label">Sumario</label>
                <input
                  type="number"
                  class="form-control"
                  v-model="updateCourse.totalMinutes"
                />
              </div>
              <div class="col-md-4 form-group mb-3">
                <label class="form-label">Vídeos totales</label>
                <input
                  type="number"
                  class="form-control"
                  v-model="updateCourse.totalVideos"
                />
              </div>
            </div>
            <h6 class="mt-4">Profesor</h6>
            <div class="form-group mb-3">
              <label class="form-label">Imagen</label>
              <input
                type="file"
                class="form-control"
                @change="uploadTeacherPicture"
                accept="image/png, image/jpg, image/jpeg"
              />
            </div>
            <div class="row">
              <div class="col-md-6 form-group mb-3">
                <label class="form-label">Nombre</label>
                <input
                  type="text"
                  class="form-control"
                  v-model="updateCourse.teacherName"
                />
              </div>
              <div class="col-md-6 form-group mb-3">
                <label class="form-label">Apellido</label>
                <input
                  type="text"
                  class="form-control"
                  v-model="updateCourse.teacherLastName"
                />
              </div>
              <div class="col-md-6 form-group mb-3">
                <label class="form-label">Descripción</label>
                <input
                  type="text"
                  class="form-control"
                  v-model="updateCourse.teacherDescription"
                />
              </div>
              <div class="col-md-6 form-group mb-3">
                <label class="form-label">Rol</label>
                <input
                  type="text"
                  class="form-control"
                  v-model="updateCourse.teacherRole"
                />
              </div>
            </div>
            <div class="form-group mb-3">
              <label class="form-check">
                <input
                  class="form-check-input"
                  type="checkbox"
                  v-model="updateCourse.isOnline"
                />
                <span class="form-check-label">Es online</span>
              </label>
            </div>
            <div class="row" v-if="updateCourse.isOnline == false">
              <div class="col-md-4 form-group mb-3">
                <label class="form-label">Horario</label>
                <input
                  type="text"
                  class="form-control"
                  v-model="updateCourse.schedule"
                />
              </div>
              <div class="col-md-4 form-group mb-3">
                <label class="form-label">Localización</label>
                <input
                  type="text"
                  class="form-control"
                  v-model="updateCourse.location"
                />
              </div>
              <div class="col-md-4 form-group mb-3">
                <label class="form-label">Fecha</label>
                <input
                  type="date"
                  class="form-control"
                  v-model="updateCourse.date"
                />
              </div>
            </div>
            <div class="form-group mb-3">
              <label class="form-check">
                <input
                  class="form-check-input"
                  type="checkbox"
                  v-model="updateCourse.enabled"
                />
                <span class="form-check-label">Activado</span>
              </label>
            </div>
            <div v-if="!course.isOnline" class="form-group mb-3 d-flex align-items-center">
              <div class="custom-toggle-container me-3">
                <input
                  type="checkbox"
                  id="ludotecaSwitch"
                  v-model="updateCourse.ludotecaOpen"
                  class="custom-toggle-input"
                  checked
                />
                <label for="ludotecaSwitch" class="custom-toggle">
                  <span class="toggle-on">Abierta</span>
                  <span class="toggle-off">Cerrada</span>
                </label>
              </div>
              <label class="form-label mb-0 ms-2">Ludoteca (disponibilidad)</label>
            </div>
          </div>
          <div class="modal-footer">
            <button :id="'submitBtn'" type="submit" class="btn btn-primary">
              Guardar
            </button>
          </div>
        </form>
      </div>
    </div>
    <div v-if="course.isOnline" class="card shadow-sm border-0 mb-3">
      <div class="card-header bg-white">
        <div class="d-flex justify-content-between">
          <h5>Lecciones</h5>
          <AddLesson :ccourse="course" />
        </div><!--../../components/Lessons/LessonRow.vue-->
      </div><!--../../components/Courses/inscriptions/InscriptionRow.vue-->
      <div class="card-body"><!--../../components/Courses/DownloadInscriptions.vue-->
        <div class="table-responsive">
          <table :key="tableKey" class="table table-bordered table-hover fixed-table">
            <thead>
              <tr>
                <th></th>
                <th>Orden</th>
                <th>Prioridad</th>
                <th>Nombre</th>
                <th>Acciones</th>
              </tr>
            </thead>
            <tbody>
              <template v-for="(group, gIdx) in groupedLessons" :key="gIdx">
                <template v-if="Array.isArray(group) && group.length > 0">
                  <draggable
                    v-if="group.length > 1"
                    :list="group"
                    group="lessons"
                    item-key="UUID"
                    tag="tbody"
                    @end="(evt) => updateOrder(evt)"
                    class="draggable-tbody"
                  >
                    <template #item="{ element }">
                      <LessonRow
                        :lesson="element"
                        :position="element.globalPosition"
                        :courseId="course.UUID"
                        :draggable="true"
                        @lesson-deleted="handleLessonDeleted"
                      />
                    </template>
                  </draggable>

                  <LessonRow
                    v-else
                    :lesson="group[0]"
                    :position="group[0].globalPosition"
                    :courseId="course.UUID"
                    :draggable="false"
                    @lesson-deleted="handleLessonDeleted"
                  />
                </template>
              </template>
            </tbody>
          </table>
        </div>
      </div>
    </div>
    <div v-if="!course.isOnline" class="card shadow-sm border-0 mb-3">
      <div class="card-header bg-white">
        <div class="d-flex justify-content-between">
          <h5>Inscripciones</h5>
        </div>
      </div>
      <div class="card-body">
        <div v-if="!loading">
          <div class="d-flex">
            <DownloadInscriptionsCSV :course="course" />

            <!-- Write user_role == 'superadmin' inside of the condition to activate the button (or false to disable it) -->
            <button
              v-if="false" 
              type="button"
              class="btn btn-outline-warning ms-2 mb-3"
              @click="syncAssistants()"
            >
              <i class="fas fa-sync-alt me-1"></i> Sincronizar Asistentes
            </button>

            <DownloadInscriptions :course="course" />
          </div>
          <div class="table-responsive">
            <table class="table table-bordered">
              <thead>
                <tr class="">
                  <th @click="toggleSort('asistentes')" style="cursor:pointer">
                    Asistentes
                    <i :class="sortKey === 'asistentes' ? (sortDir === 'asc' ? 'fas fa-sort-up' : 'fas fa-sort-down') : 'fas fa-sort'" class="ms-1 text-muted"></i>
                  </th>
                  <th @click="toggleSort('discapacidad')" style="cursor:pointer">
                    Persona con discapacidad
                    <i :class="sortKey === 'discapacidad' ? (sortDir === 'asc' ? 'fas fa-sort-up' : 'fas fa-sort-down') : 'fas fa-sort'" class="ms-1 text-muted"></i>
                  </th>
                  <th class="text-center" @click="toggleSort('createdAt')" style="cursor:pointer">
                    Fecha de inscripción
                    <i :class="sortKey === 'createdAt' ? (sortDir === 'asc' ? 'fas fa-sort-up' : 'fas fa-sort-down') : 'fas fa-sort'" class="ms-1 text-muted"></i>
                  </th>
                  <th class="text-center" @click="toggleSort('ludoteca')" style="cursor:pointer">
                    Ludoteca
                    <i :class="sortKey === 'ludoteca' ? (sortDir === 'asc' ? 'fas fa-sort-up' : 'fas fa-sort-down') : 'fas fa-sort'" class="ms-1 text-muted"></i>
                  </th>
                  <th class="text-center">Acciones</th>
                </tr>
              </thead>
              <tbody>
                <tr
                  class="align-middle"
                  :key="item"
                  v-for="item in sortedInscriptions"
                >
                  <InscriptionRow :inscription="item"></InscriptionRow>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
        <div v-else class="text-center py-5">
          <div class="spinner-border" role="status">
            <span class="visually-hidden">Loading...</span>
          </div>
          <div>Cargando información</div>
        </div>
      </div>
    </div>
  </div>
</template>

<style>
.course-icon {
  font-size: 25px;
  color: #ff9b04;
  margin-bottom: 15px;
}
.course-data {
  font-size: 18px;
  color: #000;
}
</style>

<script>
import AddLesson from "@/components/Lessons/AddLesson.vue";
import LessonRow from "@/components/Lessons/LessonRow.vue";
import InscriptionRow from "@/components/Courses/inscriptions/InscriptionRow.vue";
import DownloadInscriptions from "@/components/Courses/DownloadInscriptions.vue";
import DownloadInscriptionsCSV from "@/components/Courses/DownloadInscriptionsCSV.vue";
import LessonService from "@/services/lesson.service.js";
import CourseService from "@/services/course.service.js";
import InscriptionService from "@/services/inscription.service.js";
import draggable from "vuedraggable";
import Swal from "sweetalert2";
// import mixin
import userRoles from "@/mixins/user-roles.js";
import { QuillEditor } from "@vueup/vue-quill";
import "@vueup/vue-quill/dist/vue-quill.snow.css";

export default {
  name: "SingleCourseView",
  mixins: [userRoles],
  components: {
    QuillEditor,
    AddLesson,
    LessonRow,
    draggable,
    InscriptionRow: InscriptionRow,
    DownloadInscriptions: DownloadInscriptions,
    DownloadInscriptionsCSV: DownloadInscriptionsCSV,
  },
  computed: {
    currentUser() {
      return this.$store.state.auth.user;
    },
    sortedInscriptions() {
      const dir = this.sortDir === 'asc' ? 1 : -1;
      return [...this.inscriptions].sort((a, b) => {
        let aVal, bVal;
        if (this.sortKey === 'createdAt') {
          aVal = new Date(a.createdAt).getTime();
          bVal = new Date(b.createdAt).getTime();
        } else if (this.sortKey === 'asistentes') {
          aVal = a.assistants?.length ? `${a.assistants[0].firstName} ${a.assistants[0].lastName}` : (a.author_name || '');
          bVal = b.assistants?.length ? `${b.assistants[0].firstName} ${b.assistants[0].lastName}` : (b.author_name || '');
        } else if (this.sortKey === 'discapacidad') {
          aVal = a.disabilityPersons?.[0] ? `${a.disabilityPersons[0].firstName} ${a.disabilityPersons[0].lastName}` : '';
          bVal = b.disabilityPersons?.[0] ? `${b.disabilityPersons[0].firstName} ${b.disabilityPersons[0].lastName}` : '';
        } else if (this.sortKey === 'ludoteca') {
          aVal = a.childcare ? 1 : 0;
          bVal = b.childcare ? 1 : 0;
        }
        if (aVal < bVal) return -1 * dir;
        if (aVal > bVal) return 1 * dir;
        return 0;
      });
    },
    editor() {
      return this.$refs.quillEditor;
    },
    groupedLessons() {
      const sortedLessons = [...this.lessons].sort((a, b) => {
        if (a.priority !== b.priority) return a.priority - b.priority;
        return a.position - b.position;
      });
      const groups = {};
      sortedLessons.forEach((lesson, globalIndex) => {
        if (!groups[lesson.priority]) {
          groups[lesson.priority] = [];
        }
        lesson.globalPosition = globalIndex + 1;
        groups[lesson.priority].push(lesson);
      });
      return groups;
    },
  },
  data() {
    return {
      courseUUID: this.$route.params.courseUUID,
      course: [],
      lessons: [],
      updateCourse: {
        title: "",
        subtitle: "",
        summary: "",
        coverImage: null,
        releaseDate: "",
        totalHours: 0,
        totalMinutes: 0,
        totalVideos: 0,
        teacherName: "",
        teacherLastName: "",
        teacherPicture: null,
        teacherDescription: "",
        teacherRole: "",
        isOnline: true,
        schedule: null,
        location: null,
        date: null,
        enabled: true,
        isChildcareActive: true,
        ludotecaOpen: true,
      },
      coverImage: "",
      teacherPicture: "",
      inscriptions: [],
      sortKey: 'createdAt',
      sortDir: 'desc',
      loading: true,
      selectedLesson: null,
      showModal: false,
      updateLesson: {},
      file: null,
      tableKey: 0,
    };
  },
  methods: {
    toggleSort(key) {
      if (this.sortKey === key) {
        this.sortDir = this.sortDir === 'asc' ? 'desc' : 'asc';
      } else {
        this.sortKey = key;
        this.sortDir = 'asc';
      }
    },
    async start() {
      this.loading = true;
      await this.getCourse();
      await this.getInscriptions();
      this.loading = false;
    },
    uploadCoverImage(event) {
      this.coverImage = event.target.files[0];
    },
    uploadTeacherPicture(event) {
      this.teacherPicture = event.target.files[0];
    },
    async getCourse() {
      var response = await CourseService.getCourse(this.courseUUID);
      this.course = response.data;
      this.lessons = response.data.lessons || [];
      this.updateCourse.title = this.course.title;
      this.updateCourse.subtitle = this.course.subtitle;
      this.editor.setHTML(this.course.summary);

      console.log(this.editor);
      this.updateCourse.coverImage = this.course.coverImage;
      this.updateCourse.releaseDate = this.course.releaseDate;
      this.updateCourse.totalHours = this.course.totalHours;
      this.updateCourse.totalMinutes = this.course.totalMinutes;
      this.updateCourse.totalVideos = this.course.totalVideos;
      this.updateCourse.teacherName = this.course.teacherName;
      this.updateCourse.teacherLastName = this.course.teacherLastName;
      this.updateCourse.teacherPicture = this.course.teacherPicture;
      this.updateCourse.teacherDescription = this.course.teacherDescription;
      this.updateCourse.teacherRole = this.course.teacherRole;
      this.updateCourse.isOnline = this.course.isOnline;
      this.updateCourse.schedule = this.course.schedule;
      this.updateCourse.location = this.course.location;
      this.updateCourse.date = this.course.date;
      this.updateCourse.enabled = this.course.enabled;
      this.updateCourse.isChildcareActive = this.course.isChildcareActive;
      this.updateCourse.ludotecaOpen = this.course.isChildcareActive;
    },
    async updateOrder(evt) {
      const loadingSwal = Swal.fire({
        title: "Guardando...",
        text: "Por favor espera mientras se guarda el orden.",
        allowOutsideClick: false,
        showConfirmButton: false,
        didOpen: () => Swal.showLoading(),
      });

      try {
        if (evt && evt.from !== evt.to) {
          await loadingSwal.close();
          await Swal.fire({
            icon: "warning",
            title: "Acción no permitida",
            text: "No puedes intercambiar lecciones entre diferentes grupos de prioridad.",
            confirmButtonColor: "#ff9800",
            timer: 3000,
            timerProgressBar: true,
          });
          this.$router.go();
          return;
        }

        let updatedLessons = [];
        const sortedPriorities = Object.keys(this.groupedLessons)
          .map(Number)
          .sort((a, b) => a - b);

        let globalPosition = 1;
        
        for (const priority of sortedPriorities) {
          const group = this.groupedLessons[priority];
          if (!Array.isArray(group)) continue;
          
          for (let i = 0; i < group.length; i++) {
            group[i].position = i + 1;
            updatedLessons.push({
              UUID: group[i].UUID,
              position: globalPosition++,
              priority: group[i].priority
            });
          }
        }

        const response = await LessonService.updateLessonsOrder({
          courseUUID: this.course.UUID,
          lessons: updatedLessons
        });

        await loadingSwal.close();

        if (response.status === 200) {
          this.tableKey += 1;
          await Swal.fire({
            icon: "success",
            title: "Orden actualizado",
            text: "El orden de las lecciones se ha guardado correctamente.",
            confirmButtonColor: "#0091ff",
          });
        } else {
          throw new Error(response.data?.message || "Error en la respuesta del servidor");
        }
      } catch (error) {
        await loadingSwal.close();
        await Swal.fire({
          icon: "error",
          title: "Error",
          text: error.response?.data?.message || "Hubo un problema al actualizar el orden.",
          confirmButtonColor: "#d33",
        });
        this.tableKey++;
      }
    },
    async getInscriptions() {
      var response = await InscriptionService.getCourseInscriptions(
        this.courseUUID
      );
      this.inscriptions = response.data;
      console.log(this.inscriptions, "this.inscriptions");
    },
    formatDate(date) {
      var d = new Date(date),
        month = "" + (d.getMonth() + 1),
        day = "" + d.getDate(),
        year = d.getFullYear();
      if (month.length < 2) month = "0" + month;
      if (day.length < 2) day = "0" + day;
      return [year, month, day].join("-");
    },
    async update(evt) {
      evt.preventDefault();
      window.$("#submitBtn").empty();
      window
        .$("#submitBtn")
        .append(
          '<span class="spinner-border spinner-border-sm me-1" role="status" aria-hidden="true"></span>Guardando'
        );

      const fd = new FormData();
      if (this.coverImage != "") {
        fd.append("coverImage", this.coverImage);
      }
      if (this.teacherPicture != "") {
        fd.append("teacherPicture", this.teacherPicture);
      }
      fd.append("title", this.updateCourse.title);
      fd.append("subtitle", this.updateCourse.subtitle);
      fd.append("summary", this.updateCourse.summary);

      this.course.lessons.forEach((lesson) => {
        fd.append("lessons", lesson.UUID);
      });

      fd.append("releaseDate", this.formatDate(this.updateCourse.releaseDate));
      fd.append("totalHours", this.updateCourse.totalHours);
      fd.append("totalMinutes", this.updateCourse.totalMinutes);
      fd.append("totalVideos", this.updateCourse.totalVideos);
      fd.append("teacherName", this.updateCourse.teacherName);
      fd.append("teacherLastName", this.updateCourse.teacherLastName);
      fd.append("teacherDescription", this.updateCourse.teacherDescription);
      fd.append("teacherRole", this.updateCourse.teacherRole);
      console.log(this.updateCourse.isOnline);
      fd.append("isOnline", this.updateCourse.isOnline);
      fd.append("schedule", this.updateCourse.schedule);
      fd.append("date", this.formatDate(this.updateCourse.date));
      fd.append("location", this.updateCourse.location);
      fd.append("enabled", this.updateCourse.enabled);
      fd.append("isChildcareActive", this.updateCourse.ludotecaOpen);

      evt.preventDefault();

      let response = await CourseService.updateCourse(this.course.UUID, fd);
      window.$("#submitBtn").empty();
      window.$("#submitBtn").append("Guardar");
      if (response.status == 200) {
        Swal.fire({
          position: "top-end",
          icon: "success",
          title: "Se ha guardado correctamente.",
          showConfirmButton: false,
          timer: 1500,
          backdrop: false,
          toast: true,
        });
        this.$router.go();
      }
    },
    handleLessonDeleted(lessonUUID) {
      this.lessons = this.lessons.filter(l => l.UUID !== lessonUUID);
    },
    async syncAssistants() {
      const loadingSwal = Swal.fire({
        title: "Sincronizando...",
        text: "Buscando asistentes para inscripciones vacías.",
        allowOutsideClick: false,
        showConfirmButton: false,
        didOpen: () => Swal.showLoading(),
      });

      try {
        let response = await CourseService.updateInscriptionsAssistants(this.courseUUID);
        await loadingSwal.close();

        if (response.status === 200) {
          Swal.fire({
            icon: "success",
            title: "Sincronización completada",
            text: `Se han actualizado ${response.data.updated_inscriptions} inscripciones.`,
            confirmButtonColor: "#0091ff",
          });
          // Reload the inscriptions table to show the new names
          await this.getInscriptions();
        } else {
          throw new Error(response.data?.message || "Error del servidor");
        }
      } catch (error) {
        await loadingSwal.close();
        Swal.fire({
          icon: "error",
          title: "Error",
          text: "No se pudo completar la sincronización.",
          confirmButtonColor: "#d33",
        });
      }
    },
  },
  created() {
    this.start();
  },
  mounted() {
    if (!this.currentUser) {
      this.$router.push("/login");
    }
  },
};
</script>

<style>
/* Force draggable to behave like a proper tbody */
.draggable-tbody {
  display: contents; /* Makes the wrapper invisible to the table structure */
}

/* Fallback for browsers that don't support display: contents */
@supports not (display: contents) {
  .draggable-tbody {
    display: table-row-group;
  }
}

.custom-toggle-container {
  position: relative;
  display: inline-block;
}

.custom-toggle-input {
  display: none;
}

.custom-toggle {
  display: block;
  width: 120px;
  height: 40px;
  background-color: #dc3545; /* Red for "Cerrada" */
  border-radius: 20px;
  position: relative;
  cursor: pointer;
  transition: background-color 0.3s;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.2);
}

.custom-toggle::before {
  content: '';
  position: absolute;
  width: 56px;
  height: 36px;
  border-radius: 18px;
  background-color: white;
  top: 2px;
  left: 2px;
  transition: transform 0.3s;
  z-index: 1;
}

.custom-toggle-input:checked + .custom-toggle {
  background-color: #198754; /* Green for "Abierta" */
}

.custom-toggle-input:checked + .custom-toggle::before {
  transform: translateX(60px);
}

.toggle-on,
.toggle-off {
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
  color: white;
  font-weight: bold;
  font-size: 12px;
  z-index: 0;
}

.toggle-on {
  left: 10px;
}

.toggle-off {
  right: 10px;
}

.custom-toggle-input:checked + .custom-toggle .toggle-on {
  z-index: 2;
}

.custom-toggle-input:not(:checked) + .custom-toggle .toggle-off {
  z-index: 2;
}
</style>